import React, { Component } from "react";
import PropTypes from "prop-types";

import LineSeries from "./LineSeries";
import StaticAreaSeries from "./StaticAreaSeries";

class ATRBandsSeries extends Component {
  constructor(props) {
    super(props);
    this.yAccessorForTop = this.yAccessorForTop.bind(this);
    this.yAccessorForBottom = this.yAccessorForBottom.bind(this);
    this.yAccessorForMiddle = this.yAccessorForMiddle.bind(this);
    this.yAccessorForScalledBottom = this.yAccessorForScalledBottom.bind(this);
  }

  yAccessorForTop(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).top;
  }

  yAccessorForBottom(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).bottom;
  }

  yAccessorForMiddle(d) {
    const { yAccessor } = this.props;
    return (
      yAccessor(d) &&
      (yAccessor(d).middle ?? yAccessor(d).median ?? yAccessor(d).mid)
    );
  }

  yAccessorForScalledBottom(scale, d) {
    const { yAccessor } = this.props;
    return scale(yAccessor(d) && yAccessor(d).bottom);
  }

  render() {
    const {
      areaClassName,
      className,
      onDoubleClick,
      onContextMenu,
      channelFill,
    } = this.props;
    const { strokeTop, strokeMiddle, strokeBottom, fill } = this.props;

    const resolvedStrokeTop =
      typeof strokeTop === "string" ? { color: strokeTop } : strokeTop;
    const resolvedStrokeMiddle =
      typeof strokeMiddle === "string" ? { color: strokeMiddle } : strokeMiddle;
    const resolvedStrokeBottom =
      typeof strokeBottom === "string" ? { color: strokeBottom } : strokeBottom;
    const resolvedFillColor =
      typeof fill === "string" ? { color: fill, opacity: 1 } : fill;
    const effectiveFillOpacity =
      channelFill === false ? 0 : resolvedFillColor.opacity;
    const areaStroke = { color: "none" };

    return (
      <g className={className} style={{ cursor: "pointer" }}>
        <LineSeries
          yAccessor={this.yAccessorForTop}
          stroke={resolvedStrokeTop}
          fill="none"
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
        />
        <LineSeries
          yAccessor={this.yAccessorForMiddle}
          stroke={resolvedStrokeMiddle}
          fill="none"
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
        />
        <LineSeries
          yAccessor={this.yAccessorForBottom}
          stroke={resolvedStrokeBottom}
          fill="none"
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
        />
        <StaticAreaSeries
          className={areaClassName}
          yAccessor={this.yAccessorForTop}
          base={this.yAccessorForScalledBottom}
          stroke={areaStroke}
          fill={resolvedFillColor.color}
          opacity={effectiveFillOpacity}
        />
      </g>
    );
  }
}

ATRBandsSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  className: PropTypes.string,
  areaClassName: PropTypes.string,
  type: PropTypes.string,
  strokeTop: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
    .isRequired,
  strokeMiddle: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  strokeBottom: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
    .isRequired,
  fill: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  channelFill: PropTypes.bool,
  onDoubleClick: PropTypes.func,
  onContextMenu: PropTypes.func,
};

ATRBandsSeries.defaultProps = {
  className: "react-stockcharts-atr-bands-series",
  areaClassName: "react-stockcharts-atr-bands-series-area",
  strokeTop: { color: "#964B00" },
  strokeMiddle: { color: "#FF0000" },
  strokeBottom: { color: "#964B00" },
  fill: { color: "#4682B4", opacity: 0.2 },
  channelFill: true,
};

export default ATRBandsSeries;
